<template>
  <div class="comContent">
    <div class="search-from">
      <el-form ref="searchForm" :inline="true" style="text-align: left">
        <el-form-item>
          <el-input
            v-model="searchForm.goodsCode"
            placeholder="商品基库ID"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="searchForm.goodsName"
            placeholder="产品名称"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="searchForm.approvalNumber"
            placeholder="批准文号"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="searchForm.factory"
            placeholder="生产厂家"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-select
            size="mini"
            v-model="searchForm.goodsType"
            placeholder="商品类型"
            style="width: 120px"
          >
            <el-option
              v-for="item in goodsTypeList"
              :label="item.name"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
            size="mini"
            v-model="searchForm.checkingStatus"
            placeholder="审核结果"
            style="width: 120px"
          >
            <el-option
              v-for="item in statusList"
              :label="item.name"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content">
      <myTable
        :table-data="tableData"
        :index="index"
        :selection="false"
        :page="page"
        :showpage="true"
        :operation="false"
        v-loading="loading"
        :table-option.sync="tableOption"
        @page-change="getList"
        :expand="false"
      >
        <template slot="checkingStatus" slot-scope="scope"> 
          <span v-if="scope.row.checkingStatus == 'AWAIT'"> 待审核 </span>
          <span v-if="scope.row.checkingStatus == 'ALREADY'"> 已纠错 </span>
          <span v-if="scope.row.checkingStatus == 'CLOSE'"> 关闭 </span>
        </template>

        <template slot="concatName" slot-scope="scope">
          <span v-if="scope.row.concatName">
            {{ scope.row.concatName }}
          </span>
          <span v-if="scope.row.concatPhone">
            && {{ scope.row.concatPhone }}
          </span>
        </template>
        <!-- goodsType -->
        <template slot="goodsType" slot-scope="scope">
          <span v-if="scope.row.goodsType == 'DRUG'"> 药品 </span>
          <span v-if="scope.row.goodsType == 'FOOD'"> 食品 </span>
          <span v-if="scope.row.goodsType == 'MADI'"> 医疗器械 </span>
          <span v-if="scope.row.goodsType == 'TCMDP'"> 中药饮片 </span>
          <span v-if="scope.row.goodsType == 'OTHER'"> 其他 </span> 
          <span
            v-if="
              scope.row.goodsType != 'DRUG' &&
              scope.row.goodsType != 'FOOD' &&
              scope.row.goodsType != 'MADI' &&
              scope.row.goodsType != 'TCMDP' &&
              scope.row.goodsType != 'OTHER'
            "
          >
            {{ scope.row.goodsType }}
          </span>
        </template>
        <!-- concatName -->
        <template slot="operation" slot-scope="scope">
          <div style="margin: 0 0px">
            <el-link
              type="primary"
              :underline="false"
              @click="checkDetails(scope.row, 1)"
              style="margin-right: 10px"
            >
              查看
            </el-link>
          </div>
        </template>
        <template slot="concatName" slot-scope="scope">
        <span v-if="scope.row.concatName"> {{ scope.row.concatName }}</span>
        <span v-if="scope.row.concatPhone"> &&  {{ scope.row.concatPhone }}</span>
        </template>
      </myTable>
    </div>
  </div>
</template>
<script>
import myTable from "@/components/myTable";
import avater from "/public/img/default.png";
import getComList from "@/utils/getComList";
import GoodsThreeClass from "@/components/goodsThreeClass";
import { correctionPage } from "@/api/goodsManage/baseDepot";
import { mapGetters } from "vuex";

export default {
  components: { myTable, GoodsThreeClass },
  props: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      avater: avater,
      searchForm: {},
      statusList: [
        // { value: "PUTAWAY", name: " 上架", id: 1 },
        // { value: "SOLDOUT", name: "下架", id: 2 },
        { value: "AWAIT", name: "待审核", id: 3 },
        { value: "ALREADY", name: "已纠错", id: 4 },
        { value: "CLOSE", name: "关闭", id: 5 },
      ],
      scopeList: [],
      tableData: [],
      goodsTypeList: [],
      operation: false,
      selection: true,
      index: false,
      tableOption: [
        { label: "店铺信息", prop: "shopName", width: 260 },
        // {
        //   label: "运营人员&联系方式",
        //   prop: "concatName" ,
        //   width: 200
        //   , slot: true
        // },
        { label: "产品名称", prop: "name", width: 260 },
        { label: "批准文号", prop: "approvalNumber", width: 200 },
        { label: "生产厂家", prop: "factory", width: 200 },
        { label: "商品类型", prop: "goodsType", slot: true },
        { label: "审核人", prop: "checkName",},
        { label: "审核结果", prop: "checkingStatus", slot: true },
        { label: "修改时间", prop: "checkingTime", width: 160 },
        { label: "基库ID", prop: "goodsCode", width: 200 },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 60,
          fixed: "right",
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      isReport: true,
    };
  },
  filters: {},
  created() {},
  mounted() {
    // 获取所有商品类型
    this.typeList();
    this.getList(1);
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    async typeList() {
      this.goodsTypeList = await getComList.goodsType; //商品类型
      this.scopeList = await getComList.scopeList; //经营范围
    },

    getList(current) {
      const params = Object.assign({}, this.searchForm);
      params.size = this.page.size;
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      correctionPage(params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查看
    checkDetails(row) {
      this.$router.push( 
       `./goodsManage-correct-details?id=${row.id}&status=${row.status}&checkingStatus=${row.checkingStatus}`
      );
    },

    reset() {
      this.page.current = 1;
      this.searchForm = {}; 
      this.getList(1);
    },

    handleClose() {
      this.dialogVisible = false;
    },
    submit() {},
  },
};
</script>
<style lang="scss" scoped>
@import url("./styles/index.scss");
</style>
